/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlProfileField } from './ControlProfileField';
import {
    ControlProfileFieldFromJSON,
    ControlProfileFieldFromJSONTyped,
    ControlProfileFieldToJSON,
} from './ControlProfileField';

/**
 * 
 * @export
 * @interface ControlProfileFieldResponseAny
 */
export interface ControlProfileFieldResponseAny {
    /**
     * 
     * @type {ControlProfileField}
     * @memberof ControlProfileFieldResponseAny
     */
    field: ControlProfileField;
    /**
     * 
     * @type {any}
     * @memberof ControlProfileFieldResponseAny
     */
    value: any | null;
}

/**
 * Check if a given object implements the ControlProfileFieldResponseAny interface.
 */
export function instanceOfControlProfileFieldResponseAny(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlProfileFieldResponseAnyFromJSON(json: any): ControlProfileFieldResponseAny {
    return ControlProfileFieldResponseAnyFromJSONTyped(json, false);
}

export function ControlProfileFieldResponseAnyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlProfileFieldResponseAny {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': ControlProfileFieldFromJSON(json['field']),
        'value': json['value'],
    };
}

export function ControlProfileFieldResponseAnyToJSON(value?: ControlProfileFieldResponseAny | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': ControlProfileFieldToJSON(value.field),
        'value': value.value,
    };
}

